import { memo } from "react";
import { TableItemId } from "../../../../components/tables/TableWidget";
import { TableItemType } from "../../../../components/tables/tableContext/TableContext";
import { expeditionRoutes } from "../../../../router/routesConstants";
import ActionMenu, {
  ActionMenuItem,
} from "../../../../components/actionMenu/ActionMenu";
import { InternodeRoutesDataInterface } from "../../../../redux/interfaces/expedition.interface";

function InternodeRoutesTableActionButtons({
  itemId,
  crudData,
}: {
  itemId: TableItemId;
  tableItemData: TableItemType[];
  crudData: InternodeRoutesDataInterface;
}) {
  const goToInternodeRouteNodes = () => {
    return `/${expeditionRoutes.routesOrganizationInternode}/${itemId}/${expeditionRoutes.internodeRouteNodes}?idInternod=${itemId}&denumire=${crudData.denumire}`;
  };

  const goToOrganizeInternodeRoute = () => {
    return `/${expeditionRoutes.routesOrganizationInternode}/${expeditionRoutes.organize}?id=${itemId}&denumire=${crudData?.denumire}&cod=${crudData?.cod}`;
  };

  const items: ActionMenuItem[] = [
    {
      id: "organize",
      label: "Organizeaza ruta",
      icon: "CHANGE_ROUTE",
      section: "manage",
      tooltip: "Deschide organizarea acestei rute intranod.",
      navigate: goToOrganizeInternodeRoute(),
    },
    {
      id: "nodes",
      label: "Noduri",
      icon: "NODES",
      section: "browse",
      tooltip: "Afiseaza nodurile acestei rute intranod.",
      navigate: goToInternodeRouteNodes(),
    },
  ];

  return (
    <ActionMenu
      items={items}
      minItemsForMenu={2}
      title={crudData.denumire}
      ariaLabel={`Actiuni pentru ruta ${crudData.denumire}`}
    />
  );
}

export default memo(InternodeRoutesTableActionButtons);
